import {Notification} from "@models/notification";
import {NotificationAction} from "@enums/notificationAction";
import {Links} from "@app/links";

const getButtonDescription = (notification: Notification): string => {
    switch (notification.notification.redirect_to) {
        case NotificationAction.PROFILE:
            return "notificationTab.confirmButton";
        case NotificationAction.CONTRACTS:
            return "notificationTab.gotoButton";
        case NotificationAction.CONTRACT:
        case NotificationAction.CONTRACT_APPENDIX:
            return "notificationTab.gotoButton";
        case NotificationAction.CONTRACT_FILE:
            return "notificationTab.gotoButton";
        case NotificationAction.TIMETABLE:
            return "notificationTab.gotoButton";
        case NotificationAction.URL:
            return "notificationTab.gotoButton";
        case NotificationAction.WAREHOUSE:
            return "notificationTab.gotoButton";
    }

    return '';
};

const getButtonAction = (notification: Notification): string => {
    switch (notification.notification.redirect_to) {
        case NotificationAction.CONTRACTS:
            return Links.main + Links.contracts;
        case NotificationAction.CONTRACT:
        case NotificationAction.CONTRACT_APPENDIX:
            return Links.main + Links.contracts;
        case NotificationAction.CONTRACT_FILE:
            return Links.contract + '/' + notification.notification.redirect_to_parameter + '?selectedOption=1';
        case NotificationAction.PROFILE:
            return Links.main + Links.profile;
        case NotificationAction.WAREHOUSE:
            return Links.main + Links.workerWarehouse;
        case NotificationAction.TIMETABLE:
            return Links.main + Links.timetable + '?optionAvailability=0&notification=' + notification.notification.redirect_to_parameter;
    }

    return '';
}

export {
    getButtonDescription,
    getButtonAction,
};
